(function () {
  SigninController.$inject = ["$scope", "personService", "localStorageService"];
  app.controller('SigninController', SigninController);

  function SigninController($scope, personService, localStorageService) {
    var signinUserEmail = localStorageService.get('signInUserEmail') || '';
    var isRememberEmailAddress = signinUserEmail !== '';
    $scope.user = { user: signinUserEmail, password: '', isRememberEmailAddress: isRememberEmailAddress };
    $scope.wsErrors = { 'invalidLoginPassword': false };

    $scope.save = function () {
      if ($scope.userForm.$valid) {
        if ($scope.user.isRememberEmailAddress) {
          localStorageService.set('signInUserEmail', $scope.user.user);
        } else {
          localStorageService.remove('signInUserEmail');
        }

        $scope.requestInProgress = true;
        personService.signIn($scope.user.user, $scope.user.password).then(function (res) {
          if (res.status === 401) {
            $scope.requestInProgress = false;
            $scope.wsErrors.invalidLoginPassword = true;
          }
        });

      } else {
        $scope.wsErrors.invalidLoginPassword = true;
      }
    };
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/apps/signin/signinController.js